import { createMemo, type Component } from "solid-js";
import { renderMarkdown } from "../lib/markdown";

/** Renders a markdown string into a styled `.prose` container. */
const Markdown: Component<{ source: string; class?: string }> = (props) => {
  const html = createMemo(() => renderMarkdown(props.source));
  // Source is trusted markdown (html disabled in markdown-it); innerHTML is safe.
  return <div class={`prose ${props.class ?? ""}`} innerHTML={html()} />;
};

export default Markdown;
